import React from "react";
import ListCategory from "../Rasha/Category/ListCategory";
import ManageCategory from "../Rasha/Category/ManageCategory";
import ListProducts from "../Rasha/Products/ListProducts";
import ManageProducts from "../Rasha/Products/ManageProducts";
import NotFound from "../Components/NotFound";
import { Route, Routes } from "react-router-dom";
import AllPages from "../Rasha/Pages/AllPages";
import AllSlides from "../Rasha/Slides/AllSlides";
import ManageSlide from "../Rasha/Slides/ManageSlide";
import AllWidgets from "../Rasha/Widgets/AllWidgets";
import ManageWidget from "../Rasha/Widgets/ManageWidget";
import AllContent from "../Rasha/Content/AllContent";
import ManageContent from "../Rasha/Content/ManageContent";
import ListImageCarousel from "../Rasha/ImageCarousel/ListImageCarousel";
import ManageImageCarousel from "../Rasha/ImageCarousel/ManageImageCarousel";
import ListVideos from "../Rasha/Video/ListVideos";
import ManageVideos from "../Rasha/Video/ManageVideos";
import ListBlog from "../Rasha/Blog/ListBlog";
import ManageBlog from "../Rasha/Blog/ManageBlog";
import Contact from "../Rasha/Contact/Contact";
import ContactViewPage  from "../Rasha/Contact/ContactViewPage";


const AppRoutes2 = (props) => {

  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path="/" element={<AllPages />} />
      <Route path="/admin/rasha" element={<AllPages />} />

    
        <Route path="/admin/rasha/Category" element={<ListCategory />} />
     

        <Route
          path="/admin/rasha/Category/:CategoryID"
          element={<ManageCategory />}
        />
     
        <Route path="/admin/rasha/Products" element={<ListProducts />} />
     
        <Route
          path="/admin/rasha/Products/:ProductID"
          element={<ManageProducts />}
        />   

        <Route path="/admin/rasha/Pages" element={<AllPages />} />
 
        <Route path="/admin/rasha/Slides" element={<AllSlides />} />

        <Route path="/admin/rasha/Slides/:SlideID" element={<ManageSlide />} />
    
        <Route path="/admin/rasha/Widgets" element={<AllWidgets />} />
  
        <Route
          path="/admin/rasha/Widgets/:widgetId"
          element={<ManageWidget />}
        />
    
        <Route path="/admin/rasha/Contents" element={<AllContent />} />
   
        <Route
          path="/admin/rasha/Content/:ContentID"
          element={<ManageContent />}
        />

        <Route path="/admin/rasha/ImageCarousel" element={<ListImageCarousel />} />
   
        <Route
          path="/admin/rasha/ImageCarousel/:ImageCarouselID"
          element={<ManageImageCarousel />}
        />

         <Route path="/admin/rasha/Video" element={<ListVideos />} />
   
        <Route
          path="/admin/rasha/Video/:VideoID"
          element={<ManageVideos />}
        />

          <Route path="/admin/rasha/Blog" element={<ListBlog />} />
   
        <Route
          path="/admin/rasha/Blog/:BlogID"
          element={<ManageBlog />}
        />

             <Route path="/admin/rasha/Contact" element={<Contact />} />
    <Route path="/admin/rasha/Contact/:id" element={<ContactViewPage />} />
       
  
    </Routes>
  );
};
export default AppRoutes2;
